import { Button, CircularProgress, Grid, Typography } from "@material-ui/core";
import React, { useContext, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import isString from "lodash/isString";
import { useHistory } from "react-router-dom";

import EmailInputField from "../email-Input-Field";
import InfoIcon from "@material-ui/icons/Info";
import OtpInput, {
  INPUT_VARIANT,
} from "../../../../components/molecules/otp-input";
import PageConfig, { PageContext } from "../../configs";
import PageDomain from "../../domain";

const OTPInputField = ({ value, onChange, fieldError }) => {
  const { t } = useTranslation();
  const { NO_OF_OTP_DIGITS } = PageConfig;

  return (
    <Grid container direction="column" className="row-gap-4">
      <Typography className="typography-form-element-label py-4 text-semi-bold">
        {t("settingPage.verificationCode")}
      </Typography>
      <OtpInput
        value={value}
        onChange={onChange}
        noOfDigits={NO_OF_OTP_DIGITS}
        justifyContent="start"
        variant={INPUT_VARIANT.outline}
      />
      <Typography className="form-error-text typography-caption-1">
        {fieldError ?? ""}
      </Typography>
    </Grid>
  );
};

const OTPVerificationView = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const { token, emailAddress } = useContext(PageContext);

  const [processing, setProcessing] = useState(false);
  const [oneTimePassword, setOneTimePassword] = useState("");
  const [otpFieldError, setOtpFieldError] = useState("");

  const onClickSubmit = () => {
    PageDomain.verifyOTP({
      oneTimePassword,
      token,
      history,
      setProcessing,
      t,
      setOtpFieldError,
    });
  };

  const submitBtnDisabled = useMemo(() => {
    const { NO_OF_OTP_DIGITS } = PageConfig;
    return (
      processing ||
      (isString(oneTimePassword) && oneTimePassword.length < NO_OF_OTP_DIGITS)
    );
  }, [oneTimePassword, processing]);

  return (
    <Grid container direction="column" className="row-gap-16">
      <Typography className="typography-body-2 otp-help-banner">
        <InfoIcon />
        {t("settingPage.emailVerificationCheckEmail")}
      </Typography>
      <EmailInputField
        value={emailAddress}
        disabled={true}
        showChangeBtn={true}
      />
      <OTPInputField
        onChange={(value) => {
          setOneTimePassword(value);
        }}
        fieldError={otpFieldError}
      />
      <Button
        variant="contained"
        className="primary-button form-button"
        onClick={onClickSubmit}
        startIcon={processing && <CircularProgress size={14} color="inherit" />}
        disabled={submitBtnDisabled}
      >
        {t("common.verify")}
      </Button>
    </Grid>
  );
};

export default OTPVerificationView;
